export enum StudentAlertOrderByTypes {
  OpenAlerts,
  TotalAlerts,
  CurrentTermOpenAlerts,
  CurrentTermTotalAlerts,
  RiskFactor,
}
